import { render, staticRenderFns } from "./HomeFeed.vue?vue&type=template&id=cdde53d4&scoped=true"
import script from "../controllers/HomeFeed.ts?vue&type=script&lang=ts&external"
export * from "../controllers/HomeFeed.ts?vue&type=script&lang=ts&external"
import style0 from "./HomeFeed.vue?vue&type=style&index=0&id=cdde53d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdde53d4",
  null
  
)

export default component.exports